import React from 'react';
import { shopContext } from '../../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import { chatbotApi } from '../../../common/src';

const WidgetMemberShip = (props) => {
  const { history } = props;
  const param = props.childProps.payload.param;
  const _goHome = () => {
    props.childProps.actionProvider._home(-1);
  };

  const _go = () => {
    history.push('/ticket');
  };
  return (
    <>
      <div className="membership">
        <ul>
          {param === '멤버십' ? (
            <>
              <li>
                <div className="membership-div">
                  <img src="https://0i3z252hh7.ecn.cdn.ofs.kr/img/cashcard/member01_on.png" />
                </div>
                <div className="membership-btn" onClick={_go}>
                  구매하기
                </div>
              </li>
              <li>
                <div className="membership-div">
                  <img src="https://0i3z252hh7.ecn.cdn.ofs.kr/img/cashcard/member02_on.png" />
                </div>
                <div className="membership-btn" onClick={_go}>
                  구매하기
                </div>
              </li>
            </>
          ) : (
            <>
              <li>
                <div className="membership-div">
                  <img src="https://0i3z252hh7.ecn.cdn.ofs.kr/img/cashcard/img011_on.png" />
                </div>
                <div className="membership-btn" onClick={_go}>
                  구매하기
                </div>
              </li>
              <li>
                <div className="membership-div">
                  <img src="https://0i3z252hh7.ecn.cdn.ofs.kr/img/cashcard/img021_on.png" />
                </div>
                <div className="membership-btn" onClick={_go}>
                  구매하기
                </div>
              </li>
              <li>
                <div className="membership-div">
                  <img src="https://0i3z252hh7.ecn.cdn.ofs.kr/img/cashcard/img031_on.png" />
                </div>
                <div className="membership-btn" onClick={_go}>
                  구매하기
                </div>
              </li>
            </>
          )}
        </ul>
      </div>
      <div className="prev-chat-container">
        <div className="prev-contaner">
          <div onClick={_goHome} className="prev">
            <img src="/img/chatbot/icon_home.png" />
            처음으로
          </div>
        </div>
      </div>
    </>
  );
};

export default shopContext(withRouter(WidgetMemberShip));
